var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-box",class:{'larger': _vm.is_larger},attrs:{"is_larger":_vm.is_larger,"list":_vm.list}},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"btn",class:{'choosed': _vm.value == item.value}},[_c('button',{on:{"click":function($event){return _vm.choose(item)}}},[_vm._v(_vm._s(item.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b36ca0f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseRadio.vue
// module id = null
// module chunks = 